/* eslint-disable no-unused-vars */
import axios from "../../axios";

const url = "/permissions";

export default {
  /**
   * Get lists
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getPermissionForStudents({ commit }, payload) {
    const response = await axios.get(url + "/students", { params: payload });
    return response;
  },
};
